import "./v2-question-surface.css";

export default function ChoiceCard({
  title,
  explanation,
  selected = false,
  blooming = false,
  unavailable = false,
  nudging = false,
  onSelect,
}) {
  return (
    <button
      className="tgc-v2-choice-card"
      type="button"
      aria-pressed={selected}
      aria-disabled={unavailable || undefined}
      data-selected={selected ? "true" : "false"}
      data-blooming={blooming ? "true" : "false"}
      data-unavailable={unavailable ? "true" : "false"}
      data-nudging={nudging ? "true" : "false"}
      onClick={onSelect}
    >
      {(selected || unavailable) && (
        <span className="tgc-v2-choice-card__state">
          {selected ? "Selected" : "Limit reached"}
        </span>
      )}
      <span className="tgc-v2-choice-card__title">{title}</span>
      <span className="tgc-v2-choice-card__explanation">{explanation}</span>
    </button>
  );
}
